import { companyAdvanceConfig, siteAdvanceConfig } from '../../../constant/advanceConfig.js';

const config = {
    'searchList': {
        'searchTxt': [
            {
                'name': '月份',
                'value': 'assessmentMonth',
                'type': 'time',
                'timeType': 'month',
                'format': 'yyyy-MM',
                'placeholder': '月份',
                'unfold': true,
                'span': 4
            },
            {
                ...companyAdvanceConfig,
                'span': 4
            },
            {
                ...siteAdvanceConfig,
                unfold: true,
                'span': 4
            }
        ]
        // 'unfoldState': false,
        // 'advancedBtn': true,
        // 'resetBtn': true
    },
    'table': {
        // 'tableCut': true,
        // 'clickModify': false,
        // 'leftOperation': true,
        // 'leftWidth': 90,
        // 'selectBtn': true,
        'height': 'calc(100vh - 194px)',

        // "leftOperation": true,
        // "selectBtn": true,
        // "showIndex": true,
        'clickState': false,
        'columns': []
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};

export default config;
